import axios from "axios";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
    ? process.env.VUE_APP_BASE_API
    : process.env.VUE_APP_PUBLIC_PATH,
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
